/**
 * Validates a SMSToken against format definitions
 */
const valideSMSToken = (token) => {
  return /^[0-9]*$/.test(token)
}

export default {
  methods: {
    valideSMSToken
  }
}
